export const customerJourney = [
  { label: "Homepage", path: "/" },
  { label: "Privacy", path: "/privacy" },
  { label: "Principles", path: "/principles" },
  { label: "Your Mirror", path: "/second-brain" },
  { label: "Safety", path: "/safety" },
  { label: "Membership", path: "/pricing" },
] as const;
